<div class="SCR-all-msg-pop-area">
    <button class="pop-cls-btn" mat-dialog-close>
        <img src="assets/img/filter-close-icon.png" class="cls-icn" />
    </button>
    <div class="SCR-icn-area">
        <img src="assets/img/registar-success-green-tick.svg" class="SCR-lg-icn" />
    </div>
    <h4 class="SCR-pop-hdng">Reminder has been set!</h4>
    <p class="SCR-pop-text">You will be notified 15 mins <br>prior to the test.</p>
</div>
